import {Breadcrumb, HeaderTitle} from '@/components/atoms'
import {ProductComboFooter} from '@/containers/ProductCombo/CreateProductCombo/ProductComboFooter'
import {ProductComboStep, ProductComboSteps} from '@/containers/ProductCombo/CreateProductCombo/ProductComboStep'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {Header} from '@/utils/constants/header'
import {ROUTES} from '@/utils/constants/routesConstants'
import {
  productCombinationBreadcrumbUISchema,
  productCombinationProgressLevelSteps,
} from '@/utils/productCombo/productComboConstants'
import {ProgressIndicator} from 'pepsico-ds'
import {useMatch} from 'react-router-dom'
import {PublishedComboHeader} from './ComboDetail/PublishedComboHeader'

export const CreateProductCombo = () => {
  const {
    currentStep,
    productCombo: {isDraft},
  } = useProductCombo()
  const isComboDetailPage = Boolean(useMatch(ROUTES.PRODUCT_COMBO_DETAIL))

  const isDetailsView = currentStep === ProductComboSteps.REVIEW && isComboDetailPage

  return (
    <div className="flex flex-col gap-4">
      <Breadcrumb
        uiSchema={{
          isDark: true,
          breadcrumbs: productCombinationBreadcrumbUISchema,
        }}
        id={'product-combination-breadcrumb'}
      />
      {isDetailsView ? (
        <PublishedComboHeader />
      ) : (
        <>
          <HeaderTitle
            title={isDraft === false ? 'Edit Combo' : 'Create Combo'}
            headingLevel={Header.PageHeader}
            className="$font-heading-h3-bold"
          />
          <ProgressIndicator
            currentStep={currentStep}
            steps={4}
            titles={productCombinationProgressLevelSteps}
            isDark={false}
            className="p-6"
          />
        </>
      )}

      <ProductComboStep step={currentStep} />

      {!isDetailsView && <ProductComboFooter />}
    </div>
  )
}
